module.exports = __webpack_public_path__ + "static/media/Glasses.5153821b.jpg";